import { faker } from '@faker-js/faker';
import { define } from 'cooky-cutter';
import {
  Application,
  ApplicationMode,
  ApplicationModeVariant,
  ApplicationPrimaryKnowledgeArticle,
  ApplicationVariant,
  ApplicationVariantType,
  AppManagerPackage,
  DeveloperOrganization,
} from '../types';

export const appManagerPackageFactory = define<AppManagerPackage>({
  id: () => faker.string.uuid(),
  appManagerExternalId: () =>
    faker.string.alphanumeric({ length: 5 }).toLowerCase(),
  nameId: () => faker.lorem.word({ strategy: 'any-length' }),
  displayName: () => faker.lorem.sentence({ min: 1, max: 4 }),
  compatibleDeviceModels: () => [],
  networkCheckRequiredUrls: () => [],
  supportedRegions: () => [],
});

export const developerOrganizationFactory = define<DeveloperOrganization>({
  id: () => faker.string.uuid(),
  active: () => faker.datatype.boolean(),
  nameId: () => faker.lorem.word({ strategy: 'any-length' }),
  displayName: () => faker.lorem.sentence({ min: 1, max: 4 }),
});

export const applicationFactory = define<Application>({
  id: () => faker.string.uuid(),
  nameId: () => faker.lorem.word({ strategy: 'any-length' }),
  displayName: () => faker.lorem.sentence({ min: 1, max: 4 }),
  developerOrganization: developerOrganizationFactory,
});

export const applicationVariantFactory = define<ApplicationVariant>({
  id: () => faker.string.uuid(),
  nameId: () => faker.lorem.word({ strategy: 'any-length' }),
  displayName: () => faker.lorem.sentence({ min: 1, max: 4 }),
  type: () => faker.helpers.enumValue(ApplicationVariantType),
  active: () => faker.datatype.boolean(),
  application: applicationFactory,
  supportedLocales: () => [],
  packages: () => [],
  applicationSupplements: () => [],
});

export const applicationPrimaryKnowledgeArticleFactory =
  define<ApplicationPrimaryKnowledgeArticle>({
    id: () => faker.string.uuid(),
    title: () => faker.lorem.word({ strategy: 'any-length' }),
    url: () => faker.internet.url(),
    salesforceId: () => faker.string.uuid(),
    applicationVariant: applicationVariantFactory,
  });

export const applicationModeFactory = define<ApplicationMode>({
  id: () => faker.string.uuid(),
  nameId: () => faker.lorem.word({ strategy: 'any-length' }),
  displayName: () => faker.lorem.sentence({ min: 1, max: 4 }),
  licensingModeId: () => faker.string.uuid(),
  application: applicationFactory,
});

export const applicationModeVariantFactory = define<ApplicationModeVariant>({
  id: () => faker.string.uuid(),
  nameId: () => faker.lorem.word({ strategy: 'any-length' }),
  displayName: () => faker.lorem.sentence({ min: 1, max: 4 }),
  applicationVariant: applicationVariantFactory,
  applicationMode: applicationModeFactory,
  licensingProductGroups: () => [],
});
